import { Button } from '@/components/ui/elements/button';
import { Heading2, Paragraph } from '@/components/ui/typography/Typography';

export const NewsFeed = () => {
  return (
    <div className="border rounded p-4 pt-2 bg-background">
      <Heading2>Workplace on Pebb</Heading2>
      <Paragraph>Stay updated with the latest news and announcements.</Paragraph>

      <Button variant="outline" className="mb-4" asChild>
        <a href="https://app.pebb.io/app/main-feed" target="_blank" rel="noopener noreferrer">
          View latest posts
        </a>
      </Button>

      <Paragraph>Get the app to stay updated no matter where you are.</Paragraph>
      <div className="mt-4 flex flex-row items-center gap-4 pl-2">
        <a
          href="https://play.google.com/store/apps/details?id=io.pebbio.app"
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg width={30} height={30} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
            <path
              fill="currentColor"
              d="M293.6 234.3L72.9 13 353.7 174.2 293.6 234.3zM15.3 0C2.3 6.8-6.4 19.2-6.4 35.3l0 441.3c0 16.1 8.7 28.5 21.7 35.3L271.9 255.9 15.3 0zM440.5 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM72.9 499L353.7 337.8 293.6 277.7 72.9 499z"
            />
          </svg>
        </a>

        <a
          href="https://apps.apple.com/app/pebb/id6738578542"
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg width={40} height={40} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
            <path
              fill="currentColor"
              d="M447.1 332.7C446.9 296 463.5 268.3 497.1 247.9C478.3 221 449.9 206.2 412.4 203.3C376.9 200.5 338.1 224 323.9 224C308.9 224 274.5 204.3 247.5 204.3C191.7 205.2 132.4 248.8 132.4 337.5C132.4 363.7 137.2 390.8 146.8 418.7C159.6 455.4 205.8 545.4 254 543.9C279.2 543.3 297 526 329.8 526C361.6 526 378.1 543.9 406.2 543.9C454.8 543.2 496.6 461.4 508.8 424.6C443.6 393.9 447.1 334.6 447.1 332.7zM390.5 168.5C417.8 136.1 415.3 106.6 414.5 96C390.4 97.4 362.5 112.4 346.6 130.9C329.1 150.7 318.8 175.2 321 202.8C347.1 204.8 370.9 191.4 390.5 168.5z"
            />
          </svg>
        </a>
      </div>
    </div>
  );
};
